module.exports = __webpack_public_path__ + "static/media/medievalKnightImage_100.53baecb6.png";